module.exports = __webpack_public_path__ + "static/media/chromecast.43c9d2a6.svg";